import pickBy from 'lodash-es/pickBy';
import isNil from 'lodash-es/isNil';

export default function queryParamsMiddleware(history, options = {}) {
  const metaKey = options.metaKey || 'queryParams';

  return (/* store */) => next => action => {
    const querySpec = action.meta && action.meta[metaKey];

    if (querySpec && !action.meta.skipQueryUpdate) {
      const location = history.getCurrentLocation();
      const historyAction = action.meta.replaceQueryParams ? 'replace' : 'push';
      const pathname = action.meta.pathname || location.pathname;

      if (action.meta.mergeQueryParams) {
        history[historyAction]({
          pathname,
          query: pickBy(
            {
              ...history.getCurrentLocation().query,
              ...querySpec,
            },
            value => !isNil(value),
          ),
        });
      } else {
        history[historyAction]({
          pathname,
          query: querySpec,
        });
      }
    }

    next(action);
  };
}
